/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetEarnedPointReqQueryDto
 */
export interface GetEarnedPointReqQueryDto {
    /**
     * 현재 페이지
     * @type {number}
     * @memberof GetEarnedPointReqQueryDto
     */
    'page'?: number;
    /**
     * 한 페이지에 보여줄 데이터 수
     * @type {number}
     * @memberof GetEarnedPointReqQueryDto
     */
    'limit'?: number;
    /**
     * 시작 날짜
     * @type {string}
     * @memberof GetEarnedPointReqQueryDto
     */
    'startDate'?: string;
    /**
     * 끝 날짜
     * @type {string}
     * @memberof GetEarnedPointReqQueryDto
     */
    'endDate'?: string;
    /**
     * 포인트 카테고리 id 목록
     * @type {Array<string>}
     * @memberof GetEarnedPointReqQueryDto
     */
    'pointCategoryIds'?: Array<GetEarnedPointReqQueryDtoPointCategoryIdsEnum>;
}

export const GetEarnedPointReqQueryDtoPointCategoryIdsEnum = {
    Click: 'click',
    Install: 'install',
    Post: 'post',
    Etc: 'etc',
    Auto: 'auto',
    Plus: 'plus',
    Supporters: 'supporters',
    Guardian: 'guardian',
    Admin: 'admin',
    System: 'system'
} as const;

export type GetEarnedPointReqQueryDtoPointCategoryIdsEnum = typeof GetEarnedPointReqQueryDtoPointCategoryIdsEnum[keyof typeof GetEarnedPointReqQueryDtoPointCategoryIdsEnum];


